/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsHouse: {
  name: 'house';
  data: string;
} = {
  name: 'house',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.414 3a2 2 0 0 0-2.828 0l-7 7A2 2 0 0 0 3 11.414V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8.586A2 2 0 0 0 20.414 10l-7-7ZM16 20h3v-8.586l-7-7-7 7V20h3v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6Zm-6 0v-6h4v6h-4Z" fill="currentColor"/></svg>`,
};
